export const formatRows = (listaItems, tipovista = "completo") =>
  listaItems.map((item) => {
    const base = {
      id: item.id || "Información no disponible",
      codigo: item.art_codigo || "Información no disponible",
      descripcion: item.art_descripcion || "Información no disponible",
    };
    const show = {
      web: item.art_show_web === 0 ? "✅" : "❌",
      app: item.art_show_app === 0 ? "✅" : "❌",
    };
    switch (tipovista) {
      case "simple": // Caso 1: solo código y descripción
        return { ...base, ...show };

      case "conCosto": // Caso 2: código, descripción y precio costo
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          ...show
        };

      case "mayoristaMinorista": // Caso 3: código, descripción, precio mayorista y minorista
        return {
          ...base,
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.art_nprecioventa ?? "Información no disponible",
          ...show
        };

      case "todosPrecios": // Caso 4: código, descripción y todos los precios
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.art_nprecioventa ?? "Información no disponible",
          ...show
        }; 

      default: // Por defecto: todos los campos
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.art_nprecioventa ?? "Información no disponible", 
          ...show
        };
    }
    
  });
